// Birdseye Reviews Carousel Widget Script
window.addEventListener("elementor/frontend/init", () => {
  if (typeof elementorFrontend !== "undefined" && elementorFrontend.hooks) {
    elementorFrontend.hooks.addAction(
      "frontend/element_ready/birdseye-reviews-carousel.default",
      function ($scope) {
        const container = $scope
          .find(".birdseye-reviews-carousel-container[data-birdseye-id]")
          .get(0);

        if (!container) return;

        const birdseyeId = container.getAttribute("data-birdseye-id");
        const widgetId = container.getAttribute("data-widget-id");

        if (!birdseyeId || !widgetId) return;

        // Check if script is already loaded
        if (container.querySelector("script[data-birdseye-loaded]")) return;

        // Check if reviews are already loaded
        const widgetDivId = `bf-revz-widget-${widgetId}`;
        const existingWidgetDiv = document.getElementById(widgetDivId);
        if (existingWidgetDiv && existingWidgetDiv.innerHTML.trim() !== "") {
          // Reviews are already loaded, don't show loader
          return;
        }

        // Show loading state
        showLoadingState(container);

        // Create and inject the Birdseye script (carousel format uses /10/)
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = `https://birdeye.com/embed/v7/${birdseyeId}/10/${widgetId}`;
        script.async = true;
        script.setAttribute("data-birdseye-loaded", "true");

        // Create the widget div with correct ID format
        let widgetDiv = document.getElementById(widgetDivId);
        if (!widgetDiv) {
          widgetDiv = document.createElement("div");
          widgetDiv.id = widgetDivId;
          container.appendChild(widgetDiv);
        }

        // Handle script loading
        script.onload = function () {
          // Check for Birdseye content periodically and hide loading when found
          checkForBirdseyeContent(container, widgetDivId);
        };

        script.onerror = function () {
          hideLoadingState(container);
          showErrorState(container, "Failed to load reviews");
        };

        // Inject the script
        container.appendChild(script);

        // Fallback: hide loading after 10 seconds if nothing happens
        setTimeout(() => {
          hideLoadingState(container);
        }, 10000);
      }
    );
  }
});

// Show loading state
function showLoadingState(container) {
  const loadingHtml = `
    <div class="birdseye-reviews-carousel-loading">
      <div class="birdseye-reviews-carousel-spinner"></div>
      <p>Loading reviews...</p>
    </div>
  `;
  container.innerHTML = loadingHtml;
}

// Hide loading state
function hideLoadingState(container) {
  const loadingElement = container.querySelector(
    ".birdseye-reviews-carousel-loading"
  );
  if (loadingElement) {
    loadingElement.remove();
  }
}

// Show error state
function showErrorState(container, message) {
  const errorHtml = `
    <div class="birdseye-reviews-carousel-error">
      <p>${message}</p>
    </div>
  `;
  container.innerHTML = errorHtml;
}

// Check for Birdseye content and hide loading when found
function checkForBirdseyeContent(container, widgetDivId) {
  let attempts = 0;
  const maxAttempts = 20; // Check for 10 seconds (20 * 500ms)

  const checkInterval = setInterval(() => {
    attempts++;
    const widgetDiv = document.getElementById(widgetDivId);

    if (widgetDiv && widgetDiv.innerHTML.trim() !== "") {
      // Content found, hide loading
      hideLoadingState(container);
      clearInterval(checkInterval);
    } else if (attempts >= maxAttempts) {
      // Max attempts reached, hide loading anyway
      hideLoadingState(container);
      clearInterval(checkInterval);
    }
  }, 500); // Check every 500ms
}
